"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _tva = require("@/api/tva");

var _type_vente = require("@/api/type_vente");

var _utils = require("@/helpers/utils");

var _FactureForm = _interopRequireDefault(require("./components/FactureForm"));

var _moment = _interopRequireDefault(require("moment"));

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  name: 'FactureNew',
  components: {
    FactureForm: _FactureForm.default
  },
  data: function data() {
    return {
      action: 'new',
      dataLoaded: false,
      formData: {
        // Pré-remplir la date de facturation avec la date du jour si non-indiquée
        date_facture: (0, _moment.default)().format('YYYY-MM-DD'),
        // Rendre réactive certaines propriétés en les initialisant
        date_echeance: null,
        id_tva: null,
        id_type_vente: null
      },
      title: 'Ajouter une facture'
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['affaire'])),
  mounted: function mounted() {
    this.formData.date_echeance = this.getDateEcheance();
  },
  created: function () {
    var _created = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.setDefaultTauxTva();

            case 2:
              // await this.setDefaultTypeVente()
              this.dataLoaded = true;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    getDateEcheance: function getDateEcheance() {
      return (0, _utils.getDateEcheanceByDelaiPaiement)({
        dateFacture: this.formData.date_facture,
        delaiPaiement: this.affaire.affaire.delai_paiement
      });
    },
    setDefaultTauxTva: function setDefaultTauxTva() {
      var _this = this;

      return (0, _tva.getDefault)().then(function (results) {
        if (results.length === 1) {
          // Taux de TVA par défaut
          _this.formData.id_tva = results[0].id;
        }
      }).catch(function (error) {
        _this.$message(error);
      });
    },
    setDefaultTypeVente: function setDefaultTypeVente() {
      var _this2 = this;

      return (0, _type_vente.getDefault)().then(function (results) {
        if (results.length === 1) {
          // Type de vente par défaut
          _this2.formData.id_type_vente = results[0].id;
        }
      }).catch(function (error) {
        _this2.$message(error);
      });
    }
  }
};
exports.default = _default;